import Icon from "@ant-design/icons";
import {Image} from "antd";
import {
    KeepeIconImg
} from "../../../../assets";


export const MyIcon = (props) => <Image src={KeepeIconImg} preview={false}/>
